/**
 * personelSekmeAdaptoru.js — Firma Detay › Personel Listesi satırını Kişi Listesi kartının (PersonelKart, #531) okuduğu biçime çevirir (#728).
 *
 * İki ayrı yerden iki ayrı şekil gelir:
 *   · `row`  = GET /personnel/firma/{firmaId}/personel?sekme=  satırı  (ad · soyad · telefon · yasakli · fuarDurumu · calisanTipi ...)
 *   · `dto`  = GET /personnel/firma/{firmaId}/{personId}?fuarId=  (ham FirmaPersonelDTO: name · surname · documents · kartDurumu ·
 *              firmaBelgeGruplari · statusCounts ...) — YALNIZCA fuar kadrosundaki satırlar için okunur; yoksa kart ince kalır.
 * Kişi Listesi satırı (GET /personnel/kisi-listesi) ise kişi başına TEK satır ve firma bilgisini `firmalar[]` içinde taşır. Bu yüzden
 * burada tek girdili bir `firmalar[]` kurulur: girdi, listenin kendi firması. Böylece PersonelKart hiçbir şeyi bilmeden aynı kararı
 * (çerçeve rengi, Kart Yazdır, başlıklı gruplar, rol rozeti) verir.
 */
import { katilimAlanlari } from "./YabanciKatilimciKarti";

/**
 * @param row       sekme satırı
 * @param dto       ayrıntı okuması (yoksa null/undefined)
 * @param firmaId   listenin firması
 * @param firmaAdi  firmanın adı (profil gelene kadar null olabilir; kart "Firma #id" yazar)
 * @param fuarId    üst çubuktaki seçili fuar (yoksa rol rozeti "bu fuarda görevli değil" der)
 */
export function sekmeSatiriniKisiyeCevir({ row, dto = null, firmaId, firmaAdi = null, fuarId = null }) {
  const firma = {
    firmaId,
    firmaName: firmaAdi || null,
    // İşveren mi çalışan mı yalnızca ayrıntıdan (`owner`) bilinir; ayrıntısız satır "Çalışan" yazar (Yabancı Katılımcı kartıyla aynı).
    isveren: dto?.owner === true,
    ...katilimAlanlari(row, fuarId),
    sonFuarId: fuarId || row.sonFuarId || null,
    meslekId: dto?.meslekId ?? row.meslekId ?? null,
    meslekName: dto?.meslekName ?? row.meslekName ?? null,
    meslekler: dto?.meslekler,
    // Firmanın iki belge grubu (FIRMA · İSG): ayrıntı okumasının `firmaBelgeGruplari`ndan; ayrıntı yoksa grup da yok.
    belgeGruplari: dto?.firmaBelgeGruplari ?? [],
    kartDurumu: dto?.kartDurumu,
    kartSeviyesi: dto?.kartSeviyesi,
    kartYolu: dto?.kartYolu,
    uygunsuzluklar: dto?.uygunsuzluklar,
    cardEligible: dto?.cardEligible,
    cardEligibleReason: dto?.cardEligibleReason,
    isverenFirmaId: dto?.isverenFirmaId,
    isverenFirmaAdi: dto?.isverenFirmaAdi,
  };

  return {
    personId: row.personId,
    // Adsız kayıtta (sekme satırında ad/soyad boş olabilir) kadro ayrıntısındaki ad; o da yoksa tire.
    name: row.ad || dto?.name || (row.soyad || dto?.surname ? "" : "—"),
    surname: row.soyad || dto?.surname || "",
    tcNo: row.tcNo || row.kimlikNo || dto?.tcNo || null,
    tcNoMasked: dto?.tcNoMasked ?? null,
    phone: row.telefon || dto?.phone || null,
    forbidden: row.yasakli === true || dto?.forbidden === true,
    fotografVar: dto?.fotografVar ?? row.fotografVar,
    fotografYukleme: dto?.fotografYukleme,
    logo: dto?.logo ?? row.logo,
    uyrukId: dto?.uyrukId ?? row.uyrukId,
    kimlikDogrulama: dto?.kimlikDogrulama ?? { durum: row.kimlikDogrulamaDurum ?? 0 },
    owner: dto?.owner === true,
    // Belge kareleri, sayaçlar ve karar alanları: ayrıntı okuması yoksa hepsi boş kalır, kareler nötr gri basılır.
    documents: dto?.documents,
    gerekliBelgeler: dto?.gerekliBelgeler,
    kvkkDijitalOnay: dto?.kvkkDijitalOnay,
    kkd: dto?.kkd,
    givenVest: dto?.givenVest,
    meslekiEgitimler: dto?.meslekiEgitimler,
    etiketsizMeslekiEgitimBelgeleri: dto?.etiketsizMeslekiEgitimBelgeleri,
    statusCounts: dto?.statusCounts,
    singlePermit: dto?.singlePermit ?? null,
    kartBasim: dto?.kartBasim,
    meslekId: dto?.meslekId ?? row.meslekId ?? null,
    meslekName: dto?.meslekName ?? row.meslekName ?? null,
    meslekler: dto?.meslekler,
    firmalar: [firma],
    aktifFuardaGorevli: firma.aktifFuarda === true,
  };
}
